export const FULFILL_COMMENTS = 'COMMENTS.FULFILL';
export const CREATE_COMMENT = 'COMMENTS.CREATE';
export const DELETE_COMMENT = 'COMMENTS.DELETE';
export const UPDATE_COMMENT = 'COMMENTS.UPDATE';
export const DELETE_REPLY = 'COMMENTS.DELETE_REPLY';
export const UPDATE_REPLY = 'COMMENTS.UPDATE';
